if (!customElements.get('curated-product-preview')) {
  customElements.define('curated-product-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      const image = this.querySelector('.ce-product-image > img');
      if (!image) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const original = Object.fromEntries(['src', 'srcset', 'alt'].map(name => [name, image.getAttribute(name)]));
      let hovered = null;
      let focused = null;
      const render = () => {
        const link = hovered || focused;
        const values = link ? { src: link.dataset.previewSrc, srcset: link.dataset.previewSrcset, alt: link.dataset.previewAlt } : original;
        for (const [name, value] of Object.entries(values)) {
          if (value == null) image.removeAttribute(name);
          else image.setAttribute(name, value);
        }
      };
      this.restore = () => { hovered = focused = null; render(); };
      this.querySelectorAll('.ce-variants a[data-preview-src]').forEach(link => {
        link.addEventListener('pointerenter', event => {
          if (event.pointerType === 'touch') return;
          hovered = link;
          render();
        }, options);
        link.addEventListener('pointerleave', () => {
          if (hovered === link) hovered = null;
          render();
        }, options);
        link.addEventListener('focus', () => { focused = link; render(); }, options);
        link.addEventListener('blur', () => { focused = null; render(); }, options);
      });
      image.addEventListener('error', () => {
        hovered = focused = null;
        if (image.getAttribute('src') !== original.src) render();
      }, options);
    }
    disconnectedCallback() {
      this.restore?.();
      this.restore = null;
      this.abort?.abort();
      this.abort = null;
    }
  });
}
